import { API } from "aws-amplify";

async function updateAction(siteId: string, action: Action): Promise<Action> {
  try {
    const path: string = `/actions/${siteId}/${action.id}`;

    const options = {
      body: action
    };

    const data = await API.put(
      'api-service',
      path,
      options
    );

    return data.data as Action;
  } catch (error: any) {
    throw error;
  }
}

export default updateAction;

